import { Component, Input } from '@angular/core';
import { IPolizaVitalicia } from 'src/app/shared/Entities/entities';
import { formateaRut } from 'src/app/shared/helpers/helper';
import { productosPath } from '../../../../shared/helpers/constants';
import { Router, ActivatedRoute } from '@angular/router';
import { AppInsightsService } from 'src/app/shared/services/app-insights-service';
import { Event } from 'src/app/shared/enums/insights/event';
import { EventsService } from 'src/app/shared/services/events.service';

@Component({
  selector: 'app-card-seguro-privado',
  templateUrl: './card-seguro-privado.component.html',
  styleUrls: ['./card-seguro-privado.component.sass'],
})
export class CardSeguroPrivadoComponent {
  @Input() resumen: IPolizaVitalicia;
  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private eventService: EventsService,
    private appInsightsService: AppInsightsService
  ) {}

  viewDetail() {
    this.getPolicySelected(this.resumen.Numero);
    this.appInsightsService.trackEvent(Event.pisBtnViewMore);
    this.router.navigate(
      [
        '../' +
          productosPath.children.privado.children.detalle.path.split('/')[0],
        this.resumen.Numero,
      ],
      {
        queryParams: {
          tipo: this.resumen.Tipo,
          numPersona: this.resumen.Numero_persona,
        },
        relativeTo: this.route,
      }
    );
  }

  private getPolicySelected(idPoliza) {
    const menu = this.eventService
      .getMenu()
      .items.find(x => x.route.path === 'privado');
    const itemSelected = menu.children.find(_ => _.id == idPoliza);
    if (itemSelected) {
      this.setPolicyToInsights(itemSelected.item, 'privado');
    }
  }

  private setPolicyToInsights(policy: any, businessLine: any) {
    this.appInsightsService.policySelected = {
      code: policy.Codigo,
      clientCode: policy.CodigoCliente,
      clientId: policy.IdCliente,
      policyId: policy.IdPoliza,
      name: policy.Nombre,
      policy: policy.Poliza,
      businessLine: businessLine,
    };
  }

  formatRUT(rut: string) {
    return formateaRut(rut);
  }
}
